import { render, staticRenderFns } from "./EmployerSettings.vue?vue&type=template&id=e0b01c9a&scoped=true"
import script from "./EmployerSettings.vue?vue&type=script&lang=ts"
export * from "./EmployerSettings.vue?vue&type=script&lang=ts"
import style0 from "./EmployerSettings.vue?vue&type=style&index=0&id=e0b01c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b01c9a",
  null
  
)

export default component.exports